import Model, { attr, belongsTo } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import { DirectBookingTypes } from 'uplisting-frontend/models/property';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class DirectListingModel extends Model {
  @attr('string') nickname!: string;
  @attr('string') directBookingUrl!: string;
  @attr('string') directBookingType!: DirectBookingTypes;
  @attr('boolean', { defaultValue: true }) showOnDirectBookingEngine!: boolean;
  @attr('boolean', { defaultValue: true }) showAirbnbLink!: boolean;
  @belongsTo('photo', {
    inverse: null,
    async: false,
  })
  photo?: ModelRegistry['photo'];

  @belongsTo('base-rate', {
    inverse: null,
    async: false,
  })
  baseRate?: ModelRegistry['base-rate'];

  @cached
  get instantBookable(): boolean {
    return this.directBookingType === DirectBookingTypes.instantBook;
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'direct-listing': DirectListingModel;
  }
}
